// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__aH5ni"};